"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _menuTemplate = require("@/api/goods/menuTemplate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'menuTemplateManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      editingRowId: null,
      originalName: '',
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        type: 1,
        draftId: null
      },
      resPath: process.env.VUE_IMAGE_PATH,
      editVisible: false,
      editForm: {
        id: null,
        name: '',
        type: 1,
        beginTimeStr: null,
        endTimeStr: null,
        checkedWeekdays: [],
        checkedScene: [],
        draftId: null
      },
      editRules: {
        name: [{
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }]
      },
      timeRange: [new Date(0, 0, 0, 0, 0), new Date(0, 0, 23, 59, 59)],
      uploadFileList: [],
      previewDialog: {
        visible: false,
        url: ''
      },
      weekdays: [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }],
      scenes: [{
        label: '堂食',
        value: '1'
      }, {
        label: '自提',
        value: '2'
      }, {
        label: '外卖',
        value: '3'
      }],
      primaryMenuList: [],
      draftFlag: false
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    handleCache: function handleCache(id) {
      var _this = this;
      this.$confirm('确认要缓存该模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.listLoading = true;
        (0, _menuTemplate.cacheById)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this.$message.success('操作成功');
            _this.getList();
          } else {
            _this.$message.error(res.msg || '操作失败');
          }
        }).finally(function () {
          _this.listLoading = false;
        });
      }).catch(function () {});
    },
    handleApplyDraft: function handleApplyDraft(id) {
      var _this2 = this;
      this.$confirm('应用草稿会覆盖原模板，并使使用该模版的门店菜单均覆盖为新模板数据，确定要应用该草稿吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.applyDraft)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this2.$message.success('操作成功');
            _this2.getList();
          } else {
            _this2.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(function () {});
    },
    handleCloseDraft: function handleCloseDraft() {
      this.listQuery.draftId = null;
      this.draftFlag = false;
      this.handleFilter();
    },
    handleDraft: function handleDraft(id) {
      this.listQuery.draftId = id;
      this.draftFlag = true;
      this.handleFilter();
    },
    handleDraftCopy: function handleDraftCopy(id) {
      var _this3 = this;
      this.$confirm('确认要生成草稿吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.copyTemplateDraft)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this3.$message.success('操作成功');
            _this3.getList();
          } else {
            _this3.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(function () {});
    },
    handleCopy: function handleCopy(id) {
      var _this4 = this;
      this.$confirm('确认要复制该模版吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.copyTemplate)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this4.$message.success('操作成功');
            _this4.getList();
          } else {
            _this4.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(function () {});
    },
    handleStatus: function handleStatus(id, status) {
      var _this5 = this;
      var text = '';
      if (status == 1) {
        text = '上架';
      } else if (status == 0) {
        text = '下架';
      }
      this.$confirm('确认' + text + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.save)({
          id: id,
          status: status
        }).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this5.$message.success('操作成功');
            _this5.getList();
          } else {
            _this5.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(function () {});
    },
    handleSyncStatus: function handleSyncStatus(id) {
      var _this6 = this;
      this.$confirm('确认要将该模板的上下架状态同步到所有关联门店吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.listLoading = true;
        (0, _menuTemplate.syncStatusToStores)(id).then(function (res) {
          if (res.code === 200 || res.code === 0) {
            _this6.$message.success('下发成功');
            _this6.getList();
          } else {
            _this6.$message.error(res.msg || '下发失败');
          }
        }).finally(function () {
          _this6.listLoading = false;
        });
      }).catch(function () {});
    },
    handleDetail: function handleDetail(id) {
      // 触发事件通知父组件切换到详情页面
      this.$emit('edit-template', id);
    },
    handleEdit: function handleEdit(id) {
      var _this7 = this;
      (0, _menuTemplate.getById)(id).then(function (res) {
        _this7.editForm = res.data;
        _this7.editVisible = true;
      });
    },
    handleDelete: function handleDelete(id) {
      var _this8 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.deleteById)(id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this8.$message.success('删除成功');
            _this8.getList();
          } else {
            _this8.$message.error(res.msg || '删除失败');
          }
        });
      }).catch(function () {});
    },
    handleCreate: function handleCreate() {
      this.editForm = {
        id: null,
        name: '',
        type: 1,
        beginTimeStr: null,
        endTimeStr: null,
        checkedWeekdays: [],
        checkedScene: []
      };
      if (this.draftFlag) {
        this.editForm.draftId = this.listQuery.draftId;
      }
      this.editVisible = true;
    },
    saveEntity: function saveEntity(status) {
      var _this9 = this;
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        if (status) {
          _this9.editForm.status = status;
        }
        (0, _menuTemplate.save)(_this9.editForm).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this9.$message.success('操作成功');
            _this9.getList();
            _this9.editVisible = false;
          } else {
            _this9.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this0 = this;
      this.listLoading = true;
      (0, _menuTemplate.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this0.dataList = response.records;
          _this0.total = response.total;
        }
        setTimeout(function () {
          _this0.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this0.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    handleGroupSort: function handleGroupSort(row) {
      this.$emit('group-sort', row.id, row.name);
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.editForm.checkedWeekdays = val ? [1, 2, 3, 4, 5, 6, 7] : [];
    },
    handleNameEdit: function handleNameEdit(id) {
      var _this1 = this;
      var row = this.dataList.find(function (item) {
        return item.id === id;
      });
      if (row) {
        this.originalName = row.name;
        this.editingRowId = id;
        this.$nextTick(function () {
          var input = _this1.$refs.nameInput;
          if (input && input[0]) {
            input[0].focus();
          }
        });
      }
    },
    handleNameCancel: function handleNameCancel() {
      var _this10 = this;
      // 恢复原始值
      var row = this.dataList.find(function (item) {
        return item.id === _this10.editingRowId;
      });
      if (row && this.originalName) {
        row.name = this.originalName;
      }
      this.editingRowId = null;
      this.originalName = '';
    },
    handleNameSave: function handleNameSave(row) {
      var _this11 = this;
      if (!row.name || row.name.trim() === '') {
        this.$message.warning('模板名称不能为空');
        this.editingRowId = null;
        this.getList();
        return;
      }
      (0, _menuTemplate.save)({
        id: row.id,
        name: row.name
      }).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this11.$message.success('保存成功');
          _this11.editingRowId = null;
          _this11.originalName = '';
        } else {
          _this11.$message.error(res.msg || '保存失败');
          _this11.getList();
        }
      }).catch(function () {
        _this11.$message.error('保存失败');
        _this11.getList();
      });
    }
  }
};